// extracted by mini-css-extract-plugin
export default {"container":"order_container__rQwN4","orderDetails":"order_orderDetails__KVWWU","table":"order_table__XU7U1","count":"order_count__MiAu2"};